<template>
  <div class="customer-quotation" :class="{ rejected: is_rejected }">
    <div class="customer-quotation__info">
      <span class="date" v-text="pretty_date" />
      <span class="name" v-text="pretty_name" />
      <div class="desc" v-text="pretty_desc" />
    </div>
    <div v-if="show_clinic" class="customer-quotation__clinic">
      {{ clinic_name }}
    </div>
    <div class="customer-quotation__edit fcenter">
      <button type="button" class="btn btn-wabident-round transparent" @click="$emit('edit', quotation)">
        Editar
      </button>
    </div>
    <div class="customer-quotation__done fcenter" :class="{ done: quotation.is_approved }">
      <i class="wabident icon-wabident-icon-check" @click="$emit('approve', quotation)"></i>
    </div>
    <div @click="printQuotation" class="customer-quotation__print fcenter">
      <i class="wabident icon-wabident-print"></i>
    </div>
    <div @click="sendMail" class="customer-quotation__email fcenter">
      <i class="wabident icon-wabident-mail"></i>
    </div>
    <div class="customer-quotation__total">{{ pretty_total }}</div>
  </div>
</template>
<script>
export default {
  props: ["quotation", "customer"],
  data() {
    return {};
  },
  computed: {
    show_clinic() {
      return this.clinic && this.clinic.config.customer_unified_invoices && (Object.keys(this.clinic.clinic_names).length > 1);
    },
    clinic_name() {
      if (!this.show_clinic) {
        return '';
      }

      return this.clinic.clinic_names[this.quotation.clinic_id];
    },
    is_rejected() {
      return this.quotation &&
        this.quotation.reject_reason &&
        this.quotation.reject_reason != '';
    },
    approved_text() {
      if (!this.quotation) return 'Pendiente';
      if (this.quotation.is_approved) {
        if (this.quotation.approved_at) {
          let appr_date = moment.utc(this.quotation.approved_at).format('DD/MM/Y');
          return 'Aprobado el ' + appr_date;
        }
        return 'Aprobado';
      } else if (this.is_partial) {
        return 'Apr. Parcial';
      }

      if (this.quotation.expiry_date) {
        let exp_date = moment.utc(this.quotation.expiry_date);
        let now = moment.utc().startOf('D');
        if (now > exp_date) {
          return 'Caducado';
        }
      }

      if (this.is_rejected) {
        return 'Rechazado: ' + this.quotation.reject_reason;
      };

      return 'Pendiente';
    },
    quotation_pdf_link() {
    },
    pretty_date() {
      return moment(this.quotation.created_at).toDate().toLocaleDateString();
    },
    pretty_name() {
      if (this.is_core) {
        return `Plan #${this.quotation.code} - ${this.approved_text}`;
      } else {
        return `Presupuesto #${this.quotation.code} - ${this.approved_text}`;
      }
    },
    total() {
      return this.quotation.quotationlines.reduce((x, t) => {
        let v = (Number(t.price) * Number(t.quantity) * (1 - Number(t.discount) / 100)) - t.abs_discount;
        if (this.is_partial) {
          v = t.is_approved ? v : 0;
        }
        return x + v;
      }, 0);
    },
    pretty_total() {
      return WabiDent.fmtMoney(this.total, 0);
    },
    pretty_desc() {
      let notes = this.quotation.notes || '';

      let ret = this.quotation.quotationlines
        .map((t) => {
          if (t.product) {
            return t.product.name;
          } else {
            return "";
          }
        })
        .reduce((cur, val) => {
          return cur + " " + val;
        }, "");

      if (ret.lenght > 30) {
        ret = ret.substr(0, 30) + "...";
      }

      return notes + ' ' + ret;
    },
    is_partial() {
      if (!this.quotation) return false;
      if (this.is_approved) return false;

      let partial = false;
      this.quotation.quotationlines.forEach((line) => {
        partial = partial || line.is_approved;
      });

      return partial;
    },
    ...mapGetters(["msgwindow", "errorwindow", "clinic", "is_core"]),
  },
  methods: {
    sendMail() {
      this.msgwindow.info("Enviando ...");
      axios
        .get(`/quotation/${this.quotation.id}/email`)
        .then((response) => {
          let data = response.data;
          if (data.error) {
            this.msgwindow.error(data.message);
          } else {
            this.msgwindow.success(
              "Enviado a " + this.customer.email
            );
          }
        })
        .catch((error) => {
          console.log("[ERR] sendQuotationEmail ", error);
          this.msgwindow.error("Error enviando !");
        });
    },
    printQuotation() {
      if (this.is_partial) {
        this.errorwindow.show('Confirmación', 'Este plan está parcialmente aprobado.<br><b>¿Imprimir sólo los tratamientos aprobados o todo?</b>', 'Sólo Aprobados', 'Todos',
          () => {
            window.open(`/quotation/${this.quotation.id}/pdf?approved=true`);
          },
          () => {
            window.open(`/quotation/${this.quotation.id}/pdf`);
          }
        );
      } else {
        window.open(`/quotation/${this.quotation.id}/pdf`);
      }
    },
  },
  mounted() { },
};
</script>

<style lang="scss">
.customer-quotation {
  padding: 9px;
  background-color: var(--theme-grey-bg);
  border-bottom: 1px var(--theme-grey) solid;
  margin-bottom: 9px;
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-start;

  &.rejected {
    background-color: rgb(236, 144, 144, 0.3);
  }

  .fcenter {
    justify-content: center;
  }

  &__info {
    flex: 1 1 auto;

    .date {
      font-size: 14px;
      color: var(--theme-grey);
      font-weight: 500;
      margin-right: 10px;
    }

    .name {
      font-size: 16px;
      color: var(--theme-text-color);
      font-weight: normal;
      line-height: 1.25;
    }

    .desc {
      font-size: 12px;
      color: var(--theme-text-color);
      font-weight: 500;
    }
  }

  &__price {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    flex: 0 1 auto;
  }

  &__edit {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;

    flex: 0 0 120px;
  }

  &__clinic {
    text-transform: uppercase;
    font-size: 12px;
    font-weight: bold;
  }

  &__done,
  &__email,
  &__print {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    flex: 0 0 35px;
    cursor: pointer;
    transition: all 0.2s;

    a {
      color: inherit;
      text-decoration: none;
    }

    i {
      font-size: 24px;
    }

    &.done {
      color: var(--theme-color-attended);
    }

    &:hover {
      color: var(--theme-color);
    }
  }

  &__total {
    font-size: 18px;
    color: var(--theme-color-attended);
    letter-spacing: 0.36px;
    margin-left: 30px;
  }
}
</style>
